import Vue from 'vue';
import WidgetEventListResourceModel from '../../generated/types/model/resource/WidgetEventListResourceModel';

export function getAvailabilityString(status: string | undefined | null): string {
  switch (status) {
    case 'bookable':
      return Vue.$t('widget.events.status.bookable');
    case 'waitinglist':
      return Vue.$t('widget.events.status.waitinglist');
    case 'bookedUp':
      return Vue.$t('widget.events.status.bookedUp');
    default:
      return Vue.$t('widget.events.status.default');
  }
}

export default class WidgetEventListResourceViewModel extends WidgetEventListResourceModel {
  public get priceString():string {
    if (this.price === undefined) { return Vue.$t('widget.events.noCosts'); }
    return Vue.$format.currency(this.price!)!;
  }

  public get timeString():string | undefined {
    if (this.occurences.length > 0) {
      return this.occurences[0].timeString;
    }
    return '';
  }

  public get availabilityString():string {
    return getAvailabilityString(this.registrationStatus);
  }

  public get isBookingActionAvailable():boolean {
    return this.registrationStatus !== 'bookedUp' && this.isOnlineRegistrationActive === true;
  }

  public get hasAppointments():boolean {
    if (Vue._.isSet(this.occurences) && this.occurences.length > 0) {
      return true;
    }
    return false;
  }
}
